import React from "react";
import { Button } from "reactstrap";

class OfflineComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    checkRetry = () => {
        if (navigator.onLine) {
            this.props._checkIfOnline();
        } else {
            var x = document.getElementById("snackbar");
            x.className = "show";
            setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
        }
    }

    render() {
        return (
            <div className="centent-offline text-center">

                <div>
                    <i className="fas fa-cloud  no-internet-font" ></i>
                </div>
                <div>
                    <h4 className="m-0"> No Internet Connection</h4>
                </div>
                <div>
                    <span className="font16"> Check your connection and try again</span>
                </div>
                <div>
                    <Button className="btn-outline-primary btn-sm" size="sm" onClick={e => this.checkRetry()}>
                        <i className="fas fa-redo mr-2"></i>
                        Retry
                    </Button>
                </div>
                <div id="snackbar">Check your connection and try again...</div>
            </div>
        )
    }
}

export default OfflineComponent;

